import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, GraduationCap, Award, ChevronRight, Activity, Zap, Target, Move, Gauge, ShieldCheck } from 'lucide-react';
import { Seo } from '../components/Seo';
export function About() {
  return <div className="w-full" data-id="element-99" data-mp="29hspa5m9hkbl">
      <Seo title="About Coach Fernando Beltran | Reach Performance McKinney" description="Fernando Beltran is the Owner and Director of Performance at Reach Performance in McKinney, TX, with coaching experience from youth through professional sport." path="/about" data-id="element-100" data-mp="2ei6snacx463a" />
      <SplitHero data-id="element-101" data-mp="2samsk2aivnzz" />
      <StatsBand data-id="element-102" data-mp="2s93d2dwoxgz9" />
      <BioNarrative data-id="element-103" data-mp="2s9ldlmqdyhcz" />
      <CredentialsStrip data-id="element-104" data-mp="2schdvhpphi4l" />
      <Philosophy data-id="element-105" data-mp="2x8y2ed0thyi7" />
      <Specialties data-id="element-106" data-mp="2x8erhg9l4ado" />
      <SportsLevels data-id="element-107" data-mp="2x7mxuazjsmq1" />
      <MidCta data-id="element-108" data-mp="2xbatbfojzj7e" />
      <Facility data-id="element-109" data-mp="1guy416hmegx2" />
      <FinalCta data-id="element-110" data-mp="1gv7yb69p7a8k" />
    </div>;
}
/* ---------- MID-PAGE CTA ---------- */
function MidCta() {
  return <section className="bg-reach-red" data-id="element-111" data-mp="1lukifj96q37g">
      <div className="max-w-container mx-auto px-4 md:px-8 py-10 md:py-12 flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left" data-id="element-112" data-mp="1lvm4sjvnic4h">
        <div data-id="element-113" data-mp="1pjgv4siocitn">
          <p className="font-bebas text-white text-3xl md:text-4xl tracking-wide leading-none mb-1" data-id="element-114" data-mp="1pjqlwibjmu0e">
            Train with Reach.
          </p>
          <p className="font-inter text-white text-sm md:text-base uppercase tracking-[0.2em]" data-id="element-115" data-mp="23g3suxigbd0m">
            Start with a free athlete evaluation.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0 w-full sm:w-auto" data-id="element-116" data-mp="2df348nulpmrb">
          <Link to="/book" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm hover:-translate-y-[3px]" data-id="element-117" data-mp="28grsu8onr46z">
            Book Free Athlete Evaluation
          </Link>
          <Link to="/pricing" className="btn-secondary-dark sm:w-auto" data-id="element-118" data-mp="2r9digb8z1yj4">
            View Training Rates
          </Link>
        </div>
      </div>
    </section>;
}
/* ---------- BIO NARRATIVE ---------- */
function BioNarrative() {
  return <section className="bg-white py-20 md:py-28" data-id="element-119" data-mp="1xvb6gx79a12p">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-120" data-mp="1xuj9pj1x9xau">
        <div className="text-center mb-12" data-id="element-121" data-mp="22lrj4f395io0">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-122" data-mp="22mt6nj1gfxmm">
            Background
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none" data-id="element-123" data-mp="2ck7bele0mxz3">
            The Story
          </h2>
          <div className="w-12 h-1 bg-reach-red mt-6 mx-auto" data-id="element-124" data-mp="2glasfb7sv01w" />
        </div>

        <div className="space-y-6 font-inter text-reach-black text-base md:text-lg leading-[1.75]" data-id="element-125" data-mp="2lkx2xcw8u270">
          <p data-id="element-126" data-mp="m7t1rfc3ln2n">
            <span className="float-left font-bebas text-reach-red text-[72px] leading-[0.85] mr-3 mt-1" data-id="element-127" data-mp="m8b5ex13b3kl">
              F
            </span>
            ernando Beltran is the Owner and Director of Performance at Reach
            Performance, operating in the Dallas–Fort Worth area. He holds a
            Bachelor's Degree in Exercise Science from North Park University and
            a Master's Degree in Business Administration, with nearly a decade
            in strength and conditioning across the youth, high school,
            collegiate, and professional levels.
          </p>

          <p data-id="element-128" data-mp="12lz7qvm7zaiq">
            Before founding Reach, he built his coaching foundation inside
            collegiate strength and conditioning environments:{' '}
            <span className="font-semibold" data-id="element-129" data-mp="xnxoa9kvt96q">
              Northwestern University Football
            </span>{' '}
            (NCAA Division I),{' '}
            <span className="font-semibold" data-id="element-130" data-mp="omzjvq6j6znm">North Park University</span> (NCAA
            Division III), and{' '}
            <span className="font-semibold" data-id="element-131" data-mp="3deirlpb6ul5x">Florida Memorial University</span>{' '}
            (NAIA), sharpening an approach grounded in performance training,
            athlete development, and speed-based programming.
          </p>

          {/* Pull quote */}
          <blockquote className="my-10 border-l-4 border-reach-red bg-reach-gray pl-6 pr-5 py-6 rounded-r-[4px]" data-id="element-132" data-mp="15updin2h25aq">
            <p className="font-bebas text-reach-black text-2xl md:text-3xl tracking-wide leading-tight" data-id="element-133" data-mp="r6bcmhom8qwt">
              Hundreds of athletes coached, from youth players in their first
              season to professionals competing in the{' '}
              <span className="text-reach-red" data-id="element-134" data-mp="1jv03lnvyjfuu">MLB, NFL, NBA</span>, and pro
              soccer.
            </p>
          </blockquote>

          <p data-id="element-135" data-mp="1atsk4by3ojkt">
            The philosophy combines evidence-based principles with practical
            application. Areas of focus include{' '}
            <span className="font-semibold" data-id="element-136" data-mp="1eucbszzwmuzk">
              speed development, power training, movement efficiency, and force
              production
            </span>
            , with an emphasis on acceleration mechanics, multidirectional
            speed, strength, deceleration control, and movement quality to build
            explosive, resilient athletes.
          </p>

          <p data-id="element-137" data-mp="3n3sdjfiq5rf9">
            Every program also integrates{' '}
            <span className="font-semibold" data-id="element-138" data-mp="3n5d5qyhkgy9y">
              athlete monitoring, performance testing, and data-driven
              evaluation
            </span>{' '}
            to individualize training and track development over time. The goal:
            an elite environment that develops athletes physically and mentally,
            preparing them for long-term success in sport, and beyond it.
          </p>
        </div>
      </div>
    </section>;
}
/* ---------- SPLIT HERO ---------- */
function SplitHero() {
  return <section className="bg-white" data-id="element-139" data-mp="3ea5jbtu60w86">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px] lg:min-h-[680px]" data-id="element-140" data-mp="3e949fsovyfs1">
        <div className="relative bg-reach-black overflow-hidden order-2 lg:order-1 min-h-[400px] lg:min-h-0" data-id="element-141" data-mp="2qjtewsy4phmc">
          <img src="https://images.unsplash.com/photo-1599058917212-d750089bc07e?q=80&w=1600&auto=format&fit=crop" alt="Fernando Beltran coaching an athlete" className="absolute inset-0 w-full h-full object-cover photo-editorial" data-id="element-142" data-mp="2lli4ag00f332" />
          <div className="absolute inset-0 bg-gradient-to-tr from-black/55 via-transparent to-black/20" data-id="element-143" data-mp="3k3ietspk2tir" />
          <div className="absolute inset-0 bg-reach-red mix-blend-multiply opacity-[0.08]" data-id="element-144" data-mp="3p08u4dtjdl34" />

          <div className="absolute bottom-12 -left-10 w-[55%] h-1.5 bg-reach-red rotate-[8deg] opacity-70" data-id="element-145" data-mp="2scclpw895w2z" />
          <div className="absolute bottom-8 -left-10 w-[40%] h-1.5 bg-reach-red rotate-[8deg] opacity-40" data-id="element-146" data-mp="2wdo5hl4g3n39" />
          <div className="absolute bottom-4 -left-10 w-[28%] h-1.5 bg-reach-red rotate-[8deg] opacity-25" data-id="element-147" data-mp="31aek040lqamk" />

          <div className="absolute bottom-6 left-6 right-6 lg:bottom-10 lg:left-10 lg:right-10 z-10" data-id="element-148" data-mp="36cdoxibzpflm">
            <p className="font-inter text-white/80 text-xs uppercase tracking-[0.3em] font-semibold" data-id="element-149" data-mp="glicat2rrgcj">
              On the floor · INPOWERiQ
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-center px-6 md:px-12 lg:px-16 py-16 lg:py-0 order-1 lg:order-2" data-id="element-150" data-mp="262cmh0hpt8dg">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-4" data-id="element-151" data-mp="214krfxlrx651">
            Owner · Director of Performance
          </p>
          <h1 className="font-bebas text-reach-black text-6xl md:text-7xl lg:text-[96px] leading-[0.9] tracking-wide mb-6" data-id="element-152" data-mp="1rcybxp2ekkwh">
            Fernando
            <br data-id="element-153" data-mp="1na1mpficxqjk" />
            Beltran
          </h1>

          <div className="w-12 h-1 bg-reach-red mb-6" data-id="element-154" data-mp="1ic9uekdsw2eu" />

          <div className="space-y-4 font-inter text-reach-black text-base md:text-lg leading-relaxed max-w-xl" data-id="element-155" data-mp="1de8eg8bo8j7l">
            <p data-id="element-156" data-mp="18fdlidjzpe9r">
              Built to give Dallas–Fort Worth athletes a true performance
              environment. Structured, measurable, and grounded in the science
              of how athletes actually develop.
            </p>
            <p data-id="element-157" data-mp="32ug6pz20aa6v">
              Nearly a decade in strength and conditioning, with coaching
              experience across youth, high school, collegiate, and professional
              levels.
            </p>
            <p className="font-bebas text-reach-red text-2xl md:text-3xl tracking-wide pt-2" data-id="element-158" data-mp="2gmdq9b097ixn">
              "Every day has a purpose."
            </p>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row gap-3 sm:items-center text-sm" data-id="element-159" data-mp="26wki6jzblly5">
            <a href="mailto:Fernando@reachperformancehq.com" className="inline-flex items-center gap-2 font-inter font-semibold uppercase tracking-wider text-reach-black hover:text-reach-red transition-colors" data-id="element-160" data-mp="1sxkt5b7wb51g">
              <Mail size={16} className="text-reach-red" data-id="element-161" data-mp="1jyft20gor3n6" />
              Email Fernando
            </a>
            <span className="hidden sm:inline text-reach-black/30" data-id="element-162" data-mp="1nyhvwcy5q341">·</span>
            <a href="tel:7089804666" className="inline-flex items-center gap-2 font-inter font-semibold uppercase tracking-wider text-reach-black hover:text-reach-red transition-colors" data-id="element-163" data-mp="3ebyxzvd1poii">
              <Phone size={16} className="text-reach-red" data-id="element-164" data-mp="16mt4xni9nhum" />
              (708) 980-4666
            </a>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- CREDENTIALS STRIP ---------- */
function CredentialsStrip() {
  return <section className="bg-reach-black text-white py-16 md:py-20 relative overflow-hidden" data-id="element-165" data-mp="1bnqjzr7zbvrw">
      <div className="absolute -right-40 top-1/4 w-[40%] h-1 bg-reach-red opacity-30 rotate-[5deg]" data-id="element-166" data-mp="1qcd8ojjhxzvs" />
      <div className="absolute -right-40 top-[34%] w-[28%] h-1 bg-reach-red opacity-20 rotate-[5deg]" data-id="element-167" data-mp="1lel8714sd5fz" />

      <div className="max-w-container mx-auto px-4 md:px-8 relative" data-id="element-168" data-mp="1zdtba542kxpg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-16" data-id="element-169" data-mp="1ueglpcltdcj6">
          {/* Education */}
          <div data-id="element-170" data-mp="4za77y3vqm5b">
            <p className="font-inter text-reach-red-light text-xs uppercase tracking-[0.3em] font-semibold mb-4 flex items-center gap-2" data-id="element-171" data-mp="4yqowgabhvqr">
              <GraduationCap size={16} aria-hidden="true" data-id="element-172" data-mp="2a0rm34bhdo" />
              Education
            </p>
            <ul className="space-y-4" data-id="element-173" data-mp="3cfaq9zswjg4x">
              <li className="border-l-2 border-reach-red pl-4" data-id="element-174" data-mp="37f6885ccidcl">
                <p className="font-bebas text-2xl tracking-wide leading-none mb-1" data-id="element-175" data-mp="37dlfml9ld4hd">
                  Master of Business Administration
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-176" data-mp="2yezz0vnojzj8">
                  MBA
                </p>
              </li>
              <li className="border-l-2 border-white/20 pl-4" data-id="element-177" data-mp="3v6lbq1fuz0pf">
                <p className="font-bebas text-2xl tracking-wide leading-none mb-1" data-id="element-178" data-mp="3r46utmvr2b0s">
                  Bachelor of Science, Exercise Science
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-179" data-mp="3hdc7ef6rp5dr">
                  North Park University
                </p>
              </li>
            </ul>
          </div>

          {/* Coaching Background */}
          <div data-id="element-180" data-mp="dvln2gysav2o">
            <p className="font-inter text-reach-red-light text-xs uppercase tracking-[0.3em] font-semibold mb-4 flex items-center gap-2" data-id="element-181" data-mp="dusmjxqf51sz">
              <Award size={16} aria-hidden="true" data-id="element-182" data-mp="q6l8qlpsfrls" />
              Coaching Background
            </p>
            <ul className="space-y-4" data-id="element-183" data-mp="v5xxjc07z8r0">
              <li className="border-l-2 border-reach-red pl-4" data-id="element-184" data-mp="v4wmv8n48o9t">
                <p className="font-bebas text-xl tracking-wide leading-none mb-1" data-id="element-185" data-mp="z71a9pmz0oo0">
                  Northwestern University Football
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-186" data-mp="14647wp0mfsly">
                  NCAA Division I
                </p>
              </li>
              <li className="border-l-2 border-white/20 pl-4" data-id="element-187" data-mp="1dvxjhq0rk7q7">
                <p className="font-bebas text-xl tracking-wide leading-none mb-1" data-id="element-188" data-mp="1ivagh3lcmv6i">
                  North Park University
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-189" data-mp="1mxwzqg3yf7s3">
                  NCAA Division III
                </p>
              </li>
              <li className="border-l-2 border-white/20 pl-4" data-id="element-190" data-mp="3nytudlx5swlm">
                <p className="font-bebas text-xl tracking-wide leading-none mb-1" data-id="element-191" data-mp="3nzczu35mhsir">
                  Florida Memorial University
                </p>
                <p className="font-inter text-sm text-white/70 uppercase tracking-wider" data-id="element-192" data-mp="1k23vzjvyg50">
                  NAIA
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- PHILOSOPHY ---------- */
function Philosophy() {
  return <section className="bg-reach-gray py-20 md:py-28" data-id="element-193" data-mp="6j4ysr65j5z9">
      <div className="max-w-3xl mx-auto px-4 md:px-8" data-id="element-194" data-mp="6kpskekn6kw2">
        <div className="text-center mb-12" data-id="element-195" data-mp="kimnz7nd0l95">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-196" data-mp="kga9j4gt8t0u">
            The Philosophy
          </p>
          <h2 className="font-bebas text-5xl md:text-6xl tracking-wide leading-none" data-id="element-197" data-mp="2m8y6wx6rwm8p">
            Why We Exist
          </h2>
        </div>

        <div className="space-y-6 font-inter text-reach-black text-lg leading-relaxed" data-id="element-198" data-mp="2hchgtxg0jxsz">
          <p data-id="element-199" data-mp="wt5mm0di5l9k">
            Reach Performance combines evidence-based training principles with
            practical application that directly transfers to sport. No random
            workouts. No cookie-cutter programs. Every athlete gets training
            that matches their sport, position, and stage of development.
          </p>
          <p data-id="element-200" data-mp="e24fgp28ajex">
            Programming is periodized. Each week, each block, each season has a
            specific purpose. Group sizes are capped at 10 so every athlete gets
            coached, not just counted. Performance testing happens every four
            weeks so progress is real, measured, and undeniable.
          </p>
          <p data-id="element-201" data-mp="929pqou6vzvg">
            Athletes leave the floor knowing exactly why they did what they did,
            and how it makes them better on the field, the court, or the mound.
          </p>
        </div>
      </div>
    </section>;
}
/* ---------- SPECIALTIES ---------- */
const SPECIALTIES = [{
  Icon: Zap,
  title: 'Speed Development',
  body: 'Acceleration mechanics, top-end speed, and sprint patterning.'
}, {
  Icon: Target,
  title: 'Power Training',
  body: 'Explosive force expression: jumps, throws, change of direction.'
}, {
  Icon: Move,
  title: 'Multidirectional Speed',
  body: 'Lateral mechanics, cut technique, and reactive agility.'
}, {
  Icon: ShieldCheck,
  title: 'Deceleration Control',
  body: 'Braking force, joint integrity, and injury resilience.'
}, {
  Icon: Gauge,
  title: 'Force Production',
  body: 'Strength under load with transfer to sport-specific output.'
}, {
  Icon: Activity,
  title: 'Movement Quality',
  body: 'Mechanics, positions, and movement efficiency that hold up under fatigue.'
}];
function Specialties() {
  return <section className="bg-white py-20 md:py-28" data-id="element-202" data-mp="c2rxttk9vkye">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-203" data-mp="81g8lp5b91qq">
        <div className="text-center mb-14" data-id="element-204" data-mp="842ms7mpifhx">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-205" data-mp="2jq340hk7zpfk">
            Areas of Focus
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide leading-none" data-id="element-206" data-mp="2nszueug04pu2">
            What We Train
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-207" data-mp="2xpmbr994cyrc">
          {SPECIALTIES.map(({
          Icon,
          title,
          body
        }) => <div key={title} className="group bg-reach-gray rounded-[4px] p-7 md:p-8 border-b-4 border-transparent hover:border-reach-red hover:-translate-y-1 transition-all duration-200 ease-out flex flex-col" data-id="element-208" data-mp="2035iqg7f57be">
              <div className="w-11 h-11 bg-reach-black rounded-[4px] flex items-center justify-center mb-5" data-id="element-209" data-mp="2eqqh5wtcmicz">
                <Icon size={20} className="text-reach-red" data-id="element-210" data-mp="1hbmd01m0ff5o" />
              </div>
              <h3 className="font-bebas text-2xl tracking-wide uppercase leading-none mb-3" data-id="element-211" data-mp="1m9e792a4ndd1">
                {title}
              </h3>
              <p className="font-inter text-reach-black/80 text-base leading-relaxed" data-id="element-212" data-mp="1e7x2ecxr285n">
                {body}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- SPORTS & LEVELS ---------- */
const SPORTS = ['Football', 'Baseball', 'Basketball', 'Soccer', 'Volleyball', 'Golf', 'Tennis'];
const LEVELS = [{
  label: 'Youth',
  sub: 'Ages 8–10'
}, {
  label: 'Middle School',
  sub: 'Ages 11–13'
}, {
  label: 'High School',
  sub: 'Varsity & Recruiting'
}, {
  label: 'Collegiate',
  sub: 'NCAA · NAIA'
}, {
  label: 'Professional',
  sub: 'MLB · NFL · NBA · Pro Soccer'
}];
function SportsLevels() {
  return <section className="bg-reach-black text-white py-20 md:py-28 relative overflow-hidden" data-id="element-213" data-mp="10bjofdsfcovx">
      <div className="absolute top-0 -left-20 w-[35%] h-1 bg-reach-red rotate-[4deg] opacity-40" data-id="element-214" data-mp="2glvs3hufxe0r" />
      <div className="absolute bottom-12 -right-20 w-[35%] h-1 bg-reach-red rotate-[4deg] opacity-40" data-id="element-215" data-mp="2bodlvz7t5cwg" />

      <div className="max-w-container mx-auto px-4 md:px-8 relative" data-id="element-216" data-mp="3tod34yuon7gt">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 lg:gap-20" data-id="element-217" data-mp="2gqqigpzjunt">
          {/* Sports */}
          <div data-id="element-218" data-mp="3kmvkp9tsytoy">
            <p className="font-inter text-reach-red-light text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-219" data-mp="3kneto11h67qu">
              Sports Trained
            </p>
            <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none mb-8" data-id="element-220" data-mp="h4lks1jn6730">
              Sport-Agnostic. <br data-id="element-221" data-mp="l5dxj4rq2u41" />
              <span className="text-reach-red" data-id="element-222" data-mp="l5xa05ylsqao">Sport-Specific.</span>
            </h2>
            <div className="flex flex-wrap gap-2.5" data-id="element-223" data-mp="7e93qjb1cw1m">
              {SPORTS.map(s => <span key={s} className="inline-flex items-center px-4 py-2 border border-white/20 rounded-[4px] font-inter text-sm uppercase tracking-wider hover:border-reach-red-light hover:text-reach-red-light transition-colors" data-id="element-224" data-mp="cd3kzgtcucjm">
                  {s}
                </span>)}
            </div>
            <p className="font-inter text-white/80 text-sm mt-6 leading-relaxed max-w-md" data-id="element-225" data-mp="2w74a2a7lqi8t">
              Across all seven sports, from first-year players to starters
              competing on the biggest stages.
            </p>
          </div>

          {/* Levels */}
          <div data-id="element-226" data-mp="2m6li0s5vvvft">
            <p className="font-inter text-reach-red-light text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-227" data-mp="3jwf1h132b0aa">
              Coaching Experience By Level
            </p>
            <h2 className="font-bebas text-4xl md:text-5xl tracking-wide leading-none mb-8" data-id="element-228" data-mp="3ey53yjtv7nli">
              Youth to Pro.
            </h2>
            <p className="font-inter text-white/80 text-sm mb-6 leading-relaxed max-w-md" data-id="element-229" data-mp="35wxix3gd0j9d">
              Levels Coach Fernando has worked with over his career. Current group
              programs are listed on the programs page.
            </p>
            <ul className="space-y-3" data-id="element-230" data-mp="1ufxhnic1au37">
              {LEVELS.map(l => <li key={l.label} className="flex items-center justify-between gap-4 border-b border-white/10 pb-3" data-id="element-231" data-mp="a098dw0wjvmw">
                  <div className="flex items-center gap-3" data-id="element-232" data-mp="j0edfzimihxw">
                    <ChevronRight size={16} className="text-reach-red-light shrink-0" aria-hidden="true" data-id="element-233" data-mp="iythq6kkosyg" />
                    <span className="font-bebas text-xl tracking-wider uppercase" data-id="element-234" data-mp="spfqbgtvgj7n">
                      {l.label}
                    </span>
                  </div>
                  <span className="font-inter text-xs uppercase tracking-[0.2em] text-white/75 text-right" data-id="element-235" data-mp="11qdxg7zlx6ug">
                    {l.sub}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
/* ---------- FACILITY ---------- */
function Facility() {
  const photos = [{
    src: 'https://images.unsplash.com/photo-1540497077202-7c8a3999166f?q=80&w=1200&auto=format&fit=crop',
    alt: 'Indoor training turf with speed gates',
    caption: 'Indoor Turf'
  }, {
    src: 'https://images.unsplash.com/photo-1534438097545-a31885568541?q=80&w=1200&auto=format&fit=crop',
    alt: 'Strength and conditioning equipment',
    caption: 'Strength Floor'
  }, {
    src: 'https://images.unsplash.com/photo-1545205597-3d9d02c29597?q=80&w=1200&auto=format&fit=crop',
    alt: 'On-site recovery zone',
    caption: 'Recovery Zone'
  }];
  return <section className="bg-white py-20 md:py-28" data-id="element-236" data-mp="3g1r55afwfl4h">
      <div className="max-w-container mx-auto px-4 md:px-8" data-id="element-237" data-mp="3l02e7iyddrln">
        <div className="text-center mb-12" data-id="element-238" data-mp="3py3ujw4evctf">
          <p className="font-inter text-reach-red text-xs uppercase tracking-[0.3em] font-semibold mb-3" data-id="element-239" data-mp="3pwsua6a6cn72">
            The Facility
          </p>
          <h2 className="font-bebas text-4xl md:text-6xl tracking-wide leading-none" data-id="element-240" data-mp="1qnch6scpg2a1">
            INPOWERiQ Performance Center
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12" data-id="element-241" data-mp="cprq6xvtw9qz">
          {photos.map(p => <figure key={p.caption} className="group relative aspect-[4/5] bg-reach-black rounded-[4px] overflow-hidden" data-id="element-242" data-mp="7woscdk0qe4z">
              <img src={p.src} alt={p.alt} className="absolute inset-0 w-full h-full object-cover photo-editorial transition-transform duration-500 group-hover:scale-105" data-id="element-243" data-mp="3v3qy30ecb8yn" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" data-id="element-244" data-mp="rn0m84w2u1p1" />
              <div className="absolute top-4 left-4 w-10 h-1 bg-reach-red" data-id="element-245" data-mp="mp8vhe764lmf" />
              <figcaption className="absolute bottom-5 left-5 right-5" data-id="element-246" data-mp="hn9to8r2twrl">
                <p className="font-bebas text-white text-2xl md:text-3xl tracking-wide leading-none" data-id="element-247" data-mp="37dn4zmys2rlw">
                  {p.caption}
                </p>
              </figcaption>
            </figure>)}
        </div>

        <p className="font-inter text-reach-black text-lg md:text-xl leading-relaxed text-center max-w-3xl mx-auto" data-id="element-248" data-mp="33wqzsdpdeiri">
          24,000 sq ft. Speed gates. Indoor turf. On-site recovery. Athlete
          monitoring and performance testing built into every program.
        </p>

        <div className="text-center mt-8" data-id="element-249" data-mp="2zt2rfsswzj57">
          <a href="https://maps.google.com/?q=6051+Alma+Rd,+McKinney,+TX+75070" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-inter font-semibold uppercase tracking-wider text-sm text-reach-black hover:text-reach-red transition-colors" data-id="element-250" data-mp="2zvyqxlkeufvr">
            6051 Alma Rd · McKinney, TX 75070
            <span className="text-reach-red" data-id="element-251" data-mp="2g6ehc8wi13mo">→</span>
          </a>
        </div>
      </div>
    </section>;
}
/* ---------- STATS BAND ---------- */
function StatsBand() {
  const stats = [{
    num: '10 yrs',
    label: 'Coaching experience'
  }, {
    num: '500+',
    label: 'Athletes coached'
  }, {
    num: '4',
    label: 'Pro leagues represented'
  }, {
    num: '7',
    label: 'Sports specialized'
  }];
  return <section className="bg-reach-gray py-16 md:py-20 relative overflow-hidden border-y border-black/5" data-id="element-252" data-mp="1xim71yz23klx">
      <div className="max-w-container mx-auto px-4 md:px-8 relative" data-id="element-253" data-mp="1shgafq29zd74">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 gap-x-6" data-id="element-254" data-mp="26hzfcobg2352">
          {stats.map((s, i) => <div key={s.label} className={`text-center lg:text-left ${i !== 0 ? 'lg:border-l lg:border-black/10 lg:pl-6' : ''}`} data-id="element-255" data-mp="21jy06eh52nyv" data-mpi={i}>
              <p className="font-bebas text-reach-red text-5xl md:text-6xl lg:text-7xl leading-none mb-3 tracking-wide" data-id="element-256" data-mp="2b8ze7z44iva7">
                {s.num}
              </p>
              <p className="font-inter text-reach-black/80 text-xs md:text-sm uppercase tracking-[0.2em]" data-id="element-257" data-mp="2p9a3wytp63ts">
                {s.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}
/* ---------- FINAL CTA ---------- */
function FinalCta() {
  return <section className="bg-reach-red py-16 md:py-20" data-id="element-258" data-mp="ni08q1ghsmyj">
      <div className="max-w-container mx-auto px-4 md:px-8 text-center" data-id="element-259" data-mp="sajjkqnsp3zn">
        <h2 className="font-bebas text-white text-5xl md:text-7xl tracking-wide mb-4" data-id="element-260" data-mp="scnonbxfk91i">
          Train With Purpose.
        </h2>
        <p className="font-inter text-white text-lg md:text-xl mb-10 max-w-2xl mx-auto" data-id="element-261" data-mp="3vrjmze6r4qh2">
          Book a free athlete evaluation to find the right program for your
          athlete.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-stretch sm:items-center max-w-md sm:max-w-none mx-auto" data-id="element-262" data-mp="9jacsp5estbr">
          <Link to="/book" className="inline-flex items-center justify-center bg-white text-reach-black font-inter font-semibold px-6 min-h-[44px] md:min-h-[48px] rounded-[4px] transition-all duration-200 ease-out hover:bg-reach-black hover:text-white uppercase tracking-wide text-sm md:text-base hover:-translate-y-[3px]" data-id="element-263" data-mp="dm6nltopjl55">
            Book Free Athlete Evaluation
          </Link>
          <Link to="/pricing" className="btn-secondary-dark sm:w-auto" data-id="element-264" data-mp="35hszale5tyq6">
            View Training Rates
          </Link>
        </div>
      </div>
    </section>;
}